import React from 'react';
/**
 * SECCIÓN DE LOGOS DE CLIENTES
 *
 * Para agregar o editar logos, simplemente modifica el array 'clients' abajo.
 * Cada cliente necesita:
 * - name: Nombre del cliente (para accesibilidad)
 * - logo: URL de la imagen del logo (puede ser de Unsplash o tu servidor)
 *
 * IMPORTANTE: Usa logos en formato PNG con fondo transparente para mejor resultado.
 * Los logos se mostrarán en escala de grises y tomarán color al pasar el mouse.
 */
import { motion } from 'framer-motion';
// ============================================
// CONFIGURA TUS CLIENTES AQUÍ
// ============================================
const clients = [{
  name: 'Skechers',
  logo: 'https://cdn.magicpatterns.com/uploads/6RvEuXSZWbxWikwYgYQiSC/SKECHERS.jpg'
}, {
  name: 'Feria Chilena del Libro',
  logo: 'https://cdn.magicpatterns.com/uploads/vUVK8ufS1ajA5X2NwLSRi4/FERIA_CHILENA_DEL_LIBRO.jpg'
}, {
  name: 'BCI',
  logo: 'https://cdn.magicpatterns.com/uploads/oxMqUi6hwqTvubu3jRZ43Q/BCI.png'
}, {
  name: 'Scotiabank',
  logo: 'https://cdn.magicpatterns.com/uploads/ptMZwmGP4rkKV9zz9FFCHi/SCOTIABANK.png'
}, {
  name: 'Itaú',
  logo: 'https://cdn.magicpatterns.com/uploads/hZh3cZkBo8d7VoRw3cfV6V/ITAU.png'
}, {
  name: 'SC Johnson',
  logo: 'https://cdn.magicpatterns.com/uploads/3yzoS3tBEBUSRgUzZmEdTd/SC_JOHNSON.png'
}, {
  name: 'Komatsu Chile',
  logo: 'https://cdn.magicpatterns.com/uploads/19PFFsNupK1RX49J9AJW2K/KOMATSU_CHILE.jpg'
}, {
  name: 'Mattel Chile',
  logo: 'https://cdn.magicpatterns.com/uploads/b7USd3notYFfarrqhvZPTW/MATTEL_CHILE.png'
}, {
  name: 'UNIACC',
  logo: 'https://cdn.magicpatterns.com/uploads/fz2Xw6RXPUeaGHvLmR7Ce4/UNIACC.png'
}, {
  name: 'Morales Besa',
  logo: 'https://cdn.magicpatterns.com/uploads/mT9DB8yKDuDGRbF8zy9yBJ/MORALES_BESA.jpg'
}, {
  name: 'Albemarle',
  logo: 'https://cdn.magicpatterns.com/uploads/oa772jtVcLZCo99frXfMUF/ALBEMARLE.png'
}, {
  name: 'Laureate',
  logo: 'https://cdn.magicpatterns.com/uploads/uFgwKHy2zv48MTuAx2NqHv/LAURATE.png'
}, {
  name: 'Lápiz López',
  logo: 'https://cdn.magicpatterns.com/uploads/kgLSLDfPw3NXuL2cCks5vT/LAPIZ_LOPEZ.png'
}, {
  name: 'Banco de Chile',
  logo: 'https://cdn.magicpatterns.com/uploads/t4oX9p7LS1VRwrqvBUURGX/BANCO_DE_CHILE.png'
}, {
  name: 'BICE',
  logo: 'https://cdn.magicpatterns.com/uploads/9vBSv7wYjRYvRpghd18CWi/BICE.jpg'
}];
// ============================================
export function ClientLogos() {
  // Duplicamos los logos para crear el efecto de scroll infinito
  const duplicatedClients = [...clients, ...clients];
  return <section className="py-8 sm:py-12 md:py-16 bg-white overflow-hidden border-y border-gray-100" data-id="element-116">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 mb-8 sm:mb-12" data-id="element-117">
        <div className="text-center" data-id="element-118">
          <p className="text-xs sm:text-sm font-bold uppercase tracking-wider text-gray-500 mb-1 sm:mb-2" data-id="element-119">
            Confían en nosotros
          </p>
          <h2 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-900" data-id="element-120">
            Empresas líderes que construyen con FORAX
          </h2>
        </div>
      </div>

      {/* Contenedor de scroll infinito */}
      <div className="relative" data-id="element-121">
        {/* Gradientes laterales para efecto de fade */}
        <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-white to-transparent z-10" data-id="element-122" />
        <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-white to-transparent z-10" data-id="element-123" />

        {/* Banda de logos con animación */}
        <motion.div className="flex gap-16 items-center" animate={{
        x: [0, -1920]
      }} transition={{
        x: {
          repeat: Infinity,
          repeatType: 'loop',
          duration: 30,
          ease: 'linear'
        }
      }} data-id="element-124">
          {duplicatedClients.map((client, index) => <div key={`${client.name}-${index}`} className="flex-shrink-0 w-40 h-20 flex items-center justify-center grayscale hover:grayscale-0 opacity-60 hover:opacity-100 transition-all duration-300" data-id="element-125">
              <img src={client.logo} alt={`Logo de ${client.name}`} className="max-w-full max-h-14 object-contain" data-id="element-126" />
            </div>)}
        </motion.div>
      </div>
    </section>;
}